module.exports = __webpack_public_path__ + "img/about.ca5c18eb.png";